import Index from "./container/Index";

function App() {
  return (
    <>
      <Index/>
    </>
  );
}

export default App;
